// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'
import { throttle } from 'lodash'

export default class HeaderComponent extends Component {
  
  constructor(element) {
    super(element);
    this.ref = {
      header: null,
      headerLinks: [],
      secondaryLinks: [],
      mobileLinks: []
    }
  }
  
  mount() {
    var is_root = location.pathname == "/";
 
    if (!is_root) {
      this.addBodyMargin()
      window.addEventListener('resize', throttle(this.addBodyMargin.bind(this), 100))
    } else {
      document.documentElement.style.marginTop = `0`;
    }
 
    window.addEventListener('scroll', throttle(this.scrollClass.bind(this),100));
    // window.addEventListener('scroll', throttle(this.scrollReset.bind(this),100));
    this.checkForActive()
  }

  getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }

  addBodyMargin(e) {
    if(this.getWidth() > 1008) {
      const height = this.ref.header.offsetHeight
      document.documentElement.style.marginTop = `${height}px`;
    } else {
      document.documentElement.style.marginTop = `0`;
    }
  }


  scrollClass(e) {
    const height = this.ref.header.offsetHeight
    if (window.scrollY - (height/2) > 0) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
  }


  scrollReset(e) {
    const height = this.ref.header.offsetHeight
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
  }
 
  
  checkForActive() {
    const currentPage = window.location.href;
    if(this.ref.headerLinks.length > 0) {
      this.ref.headerLinks.forEach(link => {
        if(currentPage.startsWith(link.href)) {
          link.classList.add('current-page');
        }
      })
    }

    if(this.ref.mobileLinks.length > 0) {
      this.ref.mobileLinks.forEach(link => {
        if(currentPage.startsWith(link.href)) {
          link.classList.add('current-page');
        }
      })
    }
  }
  
}